import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import NewsSearchContext from '../../../application/Context/NewsSearchContext';
import { CleanFilterBtn } from '../doc-lib-components/Views/Filters-styles';
import { useTranslation } from "react-i18next";
export var CleanFilters = function () {
    var t = useTranslation(['news']).t;
    var _a = React.useContext(NewsSearchContext), resetFilters = _a.resetFilters, filtersIsLoading = _a.filtersIsLoading;
    return (!filtersIsLoading ? _jsxs(CleanFilterBtn, { onClick: resetFilters, children: [" ", t("Effacer les filtres")] }) : _jsx("div", { className: "spinner-border spinner-border-sm", role: "status" }));
};
